module.exports = __webpack_public_path__ + "img/restmuell.12b99adb.svg";